export const frd = (d) => (d ? d.split("-").reverse().join("/") : "");

const ST = { pending: ["En attente", "bg-amber-100 text-amber-800"], approved: ["Validée", "bg-emerald-100 text-emerald-800"],
  rejected: ["Refusée", "bg-rose-100 text-rose-800"], cancelled: ["Annulée", "bg-slate-100 text-slate-600"] };

export const AbsStatus = ({ s, id }) => {
  const [l, c] = ST[s] || [s, ""];
  return <span className={`px-2 py-0.5 rounded-full text-[11px] font-bold ${c}`} data-testid={`absence-status-${id}`}>{l}</span>;
};

export const ABS_COLORS = { CP: "bg-sky-100 text-sky-800 border-sky-300", M: "bg-rose-100 text-rose-800 border-rose-300", CSS: "bg-slate-200 text-slate-800 border-slate-400",
  AI: "bg-red-600 text-white border-red-700", AT: "bg-orange-100 text-orange-800 border-orange-300", RTT: "bg-indigo-100 text-indigo-800 border-indigo-300",
  EF: "bg-violet-100 text-violet-800 border-violet-300", IND: "bg-amber-100 text-amber-800 border-amber-300", FE: "bg-teal-100 text-teal-800 border-teal-300",
  VM: "bg-lime-100 text-lime-800 border-lime-300" };

export const AbsChip = ({ a, testid }) => (
  <span data-testid={testid} title={`${a.agent_name || ""} — ${a.label} du ${frd(a.start)} au ${frd(a.end)}${a.status === "pending" ? " (en attente)" : ""}`}
    className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border text-[10px] font-bold ${ABS_COLORS[a.short] || "bg-slate-100"} ${a.status === "pending" ? "opacity-60 border-dashed" : ""}`}>
    {a.short}{a.agent_name ? <span className="font-semibold truncate max-w-[90px]">{a.agent_name}</span> : null}
  </span>
);
